import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { Trans } from "react-i18next";

export const InviteButton = ({
  resource,
  className,
  match,
  readOnly,
  children = "Invite New",
  ...props
}) =>
  readOnly ? null : (
    <Link
      className={classNames("btn btn-primary", className)}
      to={`${match.url}/new`}
      {...props}
    >
      <span className="fa fa-plus mr-1" />
      <Trans>{children} {resource}</Trans>
    </Link>
  );

export default InviteButton;
